import { FunctionComponent } from 'react';
import '../shared/sub-menu/sub-menu.scss';
import SubMenuItem from '../shared/sub-menu/sub-menu-item';
import { ChevronRight } from '@mui/icons-material';

export type FeatureMenuItems =
  | 'features/management'
  | 'features/analysis'
  | 'features/reporting'
  | 'features/publish'
  | 'features/deployment';

export type Languages = 'de' | 'en';

export type Props = {
  selected?: FeatureMenuItems;
};

const FeatureMenu: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <div className="sub-menu-wrapper feature-menu">
      <div className="sub-menu">
        <ul>
          {/* ===================================================================== */}
          <SubMenuItem
            selected={props.selected}
            menuName={'features/management'}
            labels={[
              { language: 'de', label: 'Datenaufbereitung' },
              { language: 'en', label: 'Data Management' },
            ]}
          />
          <ChevronRight style={{ color: '#dc143c' }} />
          {/* ================================================================= */}
          <SubMenuItem
            selected={props.selected}
            menuName={'features/analysis'}
            labels={[
              { language: 'de', label: 'Datenanalyse' },
              { language: 'en', label: 'Data Analysis' },
            ]}
          />
          <ChevronRight style={{ color: '#dc143c' }} />
          {/* ================================================================ */}
          <SubMenuItem
            selected={props.selected}
            menuName={'features/reporting'}
            labels={[
              { language: 'de', label: 'Ergebnispräsentation' },
              { language: 'en', label: 'Reporting' },
            ]}
          />
          <ChevronRight style={{ color: '#dc143c' }} />
          {/* =================================================================== */}
          <SubMenuItem
            selected={props.selected}
            menuName={'features/deployment'}
            labels={[
              { language: 'de', label: 'Verteilung und Verwaltung' },
              { language: 'en', label: 'deployment' },
            ]}
          />
          <ChevronRight style={{ color: '#dc143c' }} />
          {/* ================================================================ */}
          <SubMenuItem
            selected={props.selected}
            menuName={'features/publish'}
            labels={[
              { language: 'de', label: 'Veröffentlichung und Automatisierung' },
              { language: 'en', label: 'Deployment & Automation' },
            ]}
          />
          {/* ========================================================================== */}
        </ul>
      </div>
    </div>
  );
};

export default FeatureMenu;
